import type { Application, PostApplicationFields } from '@/shared/models/applicationModel'
import type { Company } from '@/shared/models/companyModel'
import { trackEvent } from '@/shared/utils/analyticsUtils'
import { makaluApi } from '@/shared/utils/makaluApiClient'

export const listApplications = (companyId: Company['id']): Promise<Application[]> =>
    makaluApi.GET('/companies/{companyId}/applications', { params: { path: { companyId } } })

export const createApplication = async (
    companyId: Company['id'],
    payload: PostApplicationFields
): Promise<Application> => {
    const application = await makaluApi.POST('/companies/{companyId}/applications', {
        params: { path: { companyId } },
        body: { name: payload.name, description: payload.description || undefined }
    })

    trackEvent('Create_Application')

    return application
}

export const deleteApplication = async (companyId: Company['id'], id: Application['id']): Promise<Application> => {
    const application = await makaluApi.DELETE('/companies/{companyId}/applications/{applicationId}', {
        params: { path: { companyId, applicationId: id } }
    })

    trackEvent('Delete_Application')

    return application
}
